import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'

export function SettingsPermissionDenied() {
  const { t } = useTranslation('common')
  const { installationId } = useParams<{ installationId: string }>()
  const dashboardPath = installationId
    ? `/dashboard/${installationId}`
    : '/'

  return (
    <div className="flex flex-1 items-center justify-center p-6">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>{t('common:nav.permissionDenied')}</CardTitle>
          <CardDescription>
            {t('settings.permissionDeniedDescription')}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button asChild variant="secondary">
            <Link to={dashboardPath}>{t('actions.back')}</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
